import { webCampaign } from '@/modules/webCampaign';

export const getPersonalityDefault = () => {
  if (webCampaign.getLayoutNotes().includes('personality-values')) {
    return {
      shy_dominant: 89,
      serious_flirty: 23,
      logical_emotional: 19,
      affectionate_independent: 75,
    };
  }

  return {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  };
};
